
  <div class="login-container">
    <img src="../../assets/images/logos/investa-bill-white.png" alt="img" class="login-logo">
    <div class="login-box" *ngIf="!token">
      <div class="login-header">
        <h2>FORGOT PASSWORD</h2>
      </div>
      <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <input type="text" id="username" placeholder="Username" formControlName="username" required>
          <div *ngIf="f['username'].invalid && (f['username'].dirty || f['username'].touched)">
            <div class="error-msg" *ngIf="f['username'].errors?.['required']">Username is required.</div>
          </div>
        </div>
        <div class="form-group">
          <button type="submit" [disabled]="forgotPasswordForm.invalid">{{submitText}}</button>
        </div>
      </form>
      <div class="login-links">
        <a routerLink="/login">Back to Login</a>
      </div>
    </div>
    <div class="login-box" *ngIf="token">
      <div class="login-header">
        <h2>SET NEW PASSWORD</h2>
      </div>
      <form [formGroup]="resetPasswordForm" (ngSubmit)="onResetSubmit()">
        <div class="form-group">
          <input type="password" id="password" placeholder="New Password" formControlName="password" required>
          <div *ngIf="r['password'].invalid && (r['password'].dirty || r['password'].touched)">
            <div class="error-msg" *ngIf="r['password'].errors?.['required']">New Password is required.</div>
            <div class="error-msg" *ngIf="r['password'].errors?.['minlength']">Password must be at least 8 characters.</div>
          </div>
        </div>
        <div class="form-group">
          <input type="password" id="confirmPassword" placeholder="Confirm Password" formControlName="confirmPassword" required>
          <div *ngIf="r['confirmPassword'].invalid && (r['confirmPassword'].dirty || r['confirmPassword'].touched)">
            <div class="error-msg" *ngIf="r['confirmPassword'].errors?.['required']">Confirm Password is required.</div>
            <div class="error-msg" *ngIf="r['confirmPassword'].errors?.['minlength']">Password must be at least 8 characters.</div>
          </div>
          <div class="error-msg" *ngIf="resetPasswordForm.errors?.['passwordMismatch'] && (r['confirmPassword'].dirty || r['confirmPassword'].touched)">Passwords do not match</div>
        </div>
        <div class="form-group">
          <button type="submit" [disabled]="resetPasswordForm.invalid">{{submitText}}</button>
        </div>
      </form>
      <div class="login-links">
        <a routerLink="/login">Back to Login</a>
      </div>
    </div>
  </div>
